import styled from 'styled-components';

import { rem, colors, device } from '../../lib/global-styles';
import moreIcon from '../../images/ic_more.svg';
import arrowSwiper from '../../images/arrow-swiper.svg';
import checkoutCarIcon from '../../images/ic_checkout-car.svg';
import pendingPaymentIcon from '../../images/ic_info.svg';
import successPeymentIcon from '../../images/check-circle.svg';

export const ProductsBody = styled.div`
  margin: 0 auto;
  background-color: ${colors.mediumGrey};
  margin-top: -${rem(10)};
  border-radius: ${rem(8)} ${rem(8)} 0 0;

  p {
    color: ${colors.darkGrey};
    font-size: ${rem(16)};
    letter-spacing: ${rem(0.2)};
    line-height: ${rem(20)};
    margin-bottom: ${rem(16)};
  }

  @media ${device.mobile} {
    background: ${colors.background};
  }
`;

export const ProductsWrapper = styled.div`
  padding: 0 ${rem(16)};
  padding-top: ${rem(19)};

  @media ${device.desktop} {
    max-width: ${rem(1070)};
    margin: auto;
    padding-top: ${rem(38)};
  }
`;

export const ProductsListWrapper = styled.div``;

export const ProductItem = styled.div`
  background: ${colors.white};
  border-radius: ${rem(10)};
  margin-bottom: ${rem(16)};
  color: ${props => colors[props.color]};
  box-shadow: 0 ${rem(5)} ${rem(16)} 0 rgba(0, 0, 0, 0.1);

  h3 {
    font-size: ${rem(20)};
    line-height: ${rem(24)};
    letter-spacing: ${rem(1)};
  }

  p {
    line-height: ${rem(24)};
  }

  @media ${device.mobile} {
    .swiper-desktop {
      display: none;
    }
  }

  @media ${device.tablet} {
    .swiper-desktop {
      display: none;
    }
  }

  @media ${device.desktop} {
    display: flex;

    .swiper-desktop {
      display: initial;
      padding: ${rem(16)};
      overflow: hidden;
      width: 70%;
      position: relative;

      img {
        border-radius: ${rem(5)};
      }

      .swiper-button-prev,
      .swiper-button-next {
        width: ${rem(35)};
        height: ${rem(56)};
        opacity: 0.8;
      }

      .swiper-button-prev {
        background: url(${arrowSwiper});
        transform: scaleX(-1);
        left: 0;
      }

      .swiper-button-next {
        background: url(${arrowSwiper});
        right: 0;
      }
    }
  }
`;

export const ProductItemWrapper = styled.div`
  @media ${device.desktop} {
    width: 30%;
    border-right: 1px solid ${colors.grey};
  }
`;

export const ProductPrice = styled.div`
  color: ${colors.black};
  font-size: ${rem(32)};
  font-weight: bold;
  line-height: ${rem(38)};
  letter-spacing: ${rem(2)};
  margin-top: ${rem(32)};

  span {
    font-size: ${rem(16)};
  }

  @media ${device.mobile} {
    font-size: ${props => (props.secondary ? `${rem(18)}` : '')};
    margin-top: ${rem(20)};
  }
`;

export const ProductInfo = styled.div`
  padding: ${rem(24)};
  padding-bottom: 0;

  p {
    color: ${colors.darkGrey};
    font-size: ${rem(16)};
    min-height: ${rem(24)};
  }

  .swiper-mobile {
    overflow: hidden;

    img {
      border-radius: ${rem(5)};
    }
  }

  @media ${device.mobile} {
    display: ${props => (props.twoColumns ? 'flex' : 'block')};
    padding: ${rem(16)};
    padding-bottom: 0;
    align-items: center;
    justify-content: space-between;

    p.dNone {
      display: none;
    }
  }

  @media ${device.desktop} {
    .swiper-mobile {
      display: none;
    }
  }
`;

export const ProductItemFooter = styled.div`
  color: ${colors.darkGrey};
  padding: ${rem(24)};
  padding-top: 0;
  font-size: ${rem(16)};
  display: flex;
  margin-top: ${rem(32)};

  button {
    border: none;
    background-color: transparent;
    background-repeat: no-repeat;
    display: block;
  }

  @media ${device.mobile} {
    border-top: 1px solid ${colors.grey};
    padding: ${rem(16)};
    margin-top: ${rem(20)};
  }
`;

export const ListChanelsButton = styled.button`
  color: ${colors.darkGrey};
  background: url(${moreIcon});
  padding-left: ${rem(20)};
`;

export const ActionLink = styled.button`
  color: ${colors.primary};
  background: url(${checkoutCarIcon}) right;
  padding-right: ${rem(20)};
  font-weight: bold;
  margin-left: auto;

  a {
    color: ${colors.primary};
    text-decoration: none;
  }
`;

export const PaymentMethod = styled.div`
  display: flex;
  flex-direction: column;

  background: ${colors.white};
  border-radius: ${rem(10)};
  box-shadow: 0 ${rem(5)} ${rem(16)} 0 rgba(0, 0, 0, 0.1);

  padding: 20px;
  max-width: 329px;

  @media ${device.desktop} {
    flex-direction: row;
    min-width: ${props => (props.pix === 'true' ? '915px' : '590px')};
  }

  @media ${device.mobile} {
    max-width: ${rem(328)};
    flex-direction: column;
  }
`;

export const PaymentInfo = styled.div`
  display: flex;
  align-items: center;
  max-width: 340px;

  @media ${device.desktop} {
    max-width: 300px;
  }

  line-height: 25px;

  .header {
    display: flex;
    flex-direction: row;
    padding-bottom: 5px;
  }

  .title {
    font-weight: 700;
    padding-left: 5px;
    padding-top: 2px;
  }

  .icon {
    width: 20px;
    height: 20px;
    margin: 3px;
  }

  .error {
    background: rgba(225, 11, 20, 0.08);
    color: #e10b14;
    padding: 17px;
    border-radius: 8px;

    .icon {
      background: url(${pendingPaymentIcon}) no-repeat;
      background-size: contain;
    }
  }

  .success {
    background: #cff1e6;
    color: #00754e;
    padding: 17px;
    border-radius: 8px;

    .icon {
      background: url(${successPeymentIcon}) no-repeat;
      background-size: contain;
    }
  }
`;

export const Separator = styled.div`
  margin: 20px 0px 20px 0px;
  padding: 1.05px 0px 0px 0px;

  max-width: 340px;
  height: 0px;

  background: #d1d1d1;
  border-radius: 1.05px;

  @media ${device.desktop} {
    margin: 0px 20px 0px 20px;
    padding: 0px 1.05px 0px 0px;
    height: 170px;
    width: 0px;
  }
`;

export const CardInfo = styled.div`
  max-width: 340px;

  @media ${device.desktop} {
    width: max-260px;
  }

  display: flex;
  flex-direction: column
  align-items: flex-start

  color: #515151;
  line-height: 24px;

  p {
    .label {
      font-weight: 400;
      font-size: 16px;
      width: 120px;
    }

    .value {
      font-weight: 700;
      font-size: 16px;
      line-height: 0px;
    }

    span {
      display: inline-block;
      font-size: ${rem(5)};
      margin-right: ${rem(8)};
    }
  }

  .title {
    font-weight: 700;
    font-size: 20px;
    padding-bottom: 15px;
  }

  .item {
    display: flex;
    flex-direction: row;
  
    .label {
      padding-top: 3px;
      width: 120px;
    }

    .cardflag {
      img {
        border: 0.525px solid rgba(141, 141, 141, 0.5);
      }
      line-height: 0px;
    }
  }

  .filler {
    flex-grow: 2;
    min-height: 20px;
  }

  button {
    max-width: 320px;
    margin-bottom: 0px;
    padding: 0.7rem;

    @media ${device.desktop} {
      max-width: 240px;
    }
  }
`;

export const PixComponent = styled.div`
  max-width: 340px;
  padding-left: 0px;
  padding-top: 40px;

  @media ${device.desktop} {
    max-width: 300px;
    padding-left: 40px;
    padding-top: 0px;
  }

  display: flex;
  flex-direction: column
  align-items: flex-start

  color: #515151;
  line-height: 24px;

  p {
    .label {
      font-weight: 400;
      font-size: 16px;
      width: 120px;
    }

    .value {
      font-weight: 700;
      font-size: 16px;
      line-height: 0px;
    }

    span {
      display: inline-block;
      margin-right: ${rem(8)};
    }
  }

  .title {
    font-weight: 700;
    font-size: 20px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: row;

    .title-tag {
      font-weight: bold;
      display: flex;
      flex-direction: row;
      .icon {
        background: url(${successPeymentIcon}) no-repeat;
        background-size: contain;
        width: 20px;
      }
      background: #cff1e6;
      color: #00754e;
      padding: 5px 9px 0px 9px;
      gap: 3px;
      border-radius: 60px;
      font-size: 12px;
      margin-left: 13px;
      margin-top: -6px;
    }
  }

  .item {
    display: flex;
    flex-direction: row;

    .label {
      padding-top: 3px;
      width: 120px;
    }

    .value {
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 170px;
      @media ${device.desktop} {
        max-width: 166px;
      }
    }
  }

  .filler {
    flex-grow: 2;
    min-height: 20px;
  }

  button {
    max-width: 320px;
    margin-bottom: 0px;
    padding: 0.7rem;

    @media ${device.desktop} {
      max-width: 240px;
    }
  }
`;

export const PixIframe = styled.div`
  iframe {
    width: 296px;
    height: 426px;

    @media ${device.desktop} {
      height: 601px;
    }
  }
`;

export const DigitalSubscription = styled.div`
  background: ${colors.white};
  padding: ${rem(20)};
  border-radius: ${rem(10)};
  box-shadow: 0 ${rem(5)} ${rem(16)} 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  p {
    display: flex;
    color: ${colors.darkGrey};
    align-items: center;
    margin-top: ${rem(16)};
  }

  div {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  max-width: ${rem(328)};
`;

export const SubscriptionInfoBody = styled.div`
  @media ${device.desktop} {
    background: ${colors.mediumGrey};
    margin-top: -${rem(10)};
    border-radius: ${rem(8)} ${rem(8)} 0 0;
  }

  padding-bottom: ${rem(30)};
`;

export const CardEditWrapper = styled.div`
  width: ${rem(320)};
  margin: auto;
`;